// import apiUrl from '../../../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import annexures from './annexures/index.vue';
import rates from './rates/index.vue';
//import services from './services/index.vue';
import services from './newservices';
import tc from './t&c/index.vue';

export default {
	name: 'Template1',
	components: {
		'first': services,
		'second': rates,
		'third': tc,
		'fourth': annexures,
		services
	},
	props: ['selectedEdit', 'callingFromClientContract'],

	data() {
		return {
			selectedEditRow: this.selectedEdit &&  JSON.parse(JSON.stringify(this.selectedEdit)),
			callingFromClientContractObj: this.callingFromClientContract && JSON.parse(JSON.stringify(this.callingFromClientContract)),
			countObj: {},
			disabled: true,
			lock: true,
			unlock: false,
			showTemplate:true,
			contractidd: '',
			parentmessage: '',
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: 'Services'
				},
				{
					key: 'Second',
					value: 'Rates'
				},
				{
					key: 'Third',
					value: 'T&C'
				},
				{
					key: 'Fourth',
					value: 'Annexures'
				}
			],
		}
	},
	created: function() {

	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1;
			return this.currentTab.toLowerCase()
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.contractidd = (this.callingFromClientContract && this.callingFromClientContract.existingContractTemplateId) ||(!this.callingFromClientContract && this.selectedEdit && this.selectedEdit.id);
		})
	},
	methods: {
		goBackToCreateContract(payload, buttonclick) {
			this.$emit('goBackToCreateContract', payload, buttonclick)
		},
		checkForContractValidation(){
			this.$emit('checkForContractValidation')
		},

		getContractID(contractid, buttonclick) {
			this.$nextTick(() => {
				this.contractidd = contractid;
			})
			if (buttonclick == 'Save') {
				this.contractidd = contractid;
				this.$refs.Template1Ref.getContractIDFromTemplate1(contractid, buttonclick);
			} else if (buttonclick == "SaveServiceAndNext") {
				this.changeTab(contractid, buttonclick)
				// this.componentKey = 3;
				// this.currentTab = 'Third';
				// this.$nextTick(() => {
				//   this.$refs.Template1Ref.getContractIDFromTemplate1(contractid, buttonclick);
				// })
			}
		},

		setTab(tab){
			this.showTemplate = false;
			this.$nextTick(() => {
				let currentTabIndex = 0;
				this.tabs.forEach((el, index) => {
					if (el.key == tab) {
						currentTabIndex = index;
					}
				})

				this.componentKey = currentTabIndex;
				this.currentTab = this.tabs[this.componentKey].key;
				this.showTemplate = true;
			})
		  },

		changeTab(contractid, buttonclick) {
			this.$nextTick(() => {
				if (buttonclick == "SaveTCAndNext") {
					this.componentKey = 3;
					this.currentTab = 'Fourth';
					// this.$nextTick(() => {
					// 	this.$refs.Template1Ref.getContractIDFromTemplate1(contractid, buttonclick);
					// })
				} else if (buttonclick == "SaveServiceAndNext") {
					this.componentKey = 1;
					this.currentTab = 'Second';
					// this.$nextTick(() => {
					// 	this.$refs.Template1Ref.getContractIDFromTemplate1(contractid, buttonclick);
					// })
				}
			})

		},
	}
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/Template1/Template1.component.js